import get_filedata from "./get_filedata"

export default (path: string): string => {
  const { basename, ext } = get_filedata(path)
  return ext ? `${basename}.${ext}` : basename
}
